"use client";
import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useCallback, useContext, useState, } from "react";
const defaultOptions = {
    showMainMenuButton: false,
    showBackButton: false,
};
const HeaderContext = createContext(null);
export function HeaderProvider({ children }) {
    const [options, setOptions] = useState(defaultOptions);
    const setHeaderOptions = useCallback((opts) => {
        setOptions((prev) => (Object.assign(Object.assign({}, prev), opts)));
    }, []);
    return (_jsx(HeaderContext.Provider, { value: Object.assign(Object.assign({}, options), { setHeaderOptions }), children: children }));
}
export function useHeaderOptions() {
    const ctx = useContext(HeaderContext);
    return ctx !== null && ctx !== void 0 ? ctx : Object.assign(Object.assign({}, defaultOptions), { setHeaderOptions: () => { } });
}
export function useSetHeaderOptions() {
    var _a;
    const ctx = useContext(HeaderContext);
    return (_a = ctx === null || ctx === void 0 ? void 0 : ctx.setHeaderOptions) !== null && _a !== void 0 ? _a : (() => { });
}
